import { css } from '@emotion/css';
import c from 'classnames';

export const breadcrumb = (size: string) => css`
  max-width: ${size === 'small' ? '14.4rem' : '38.4rem'};
  li:last-child & {
    max-width: ${size === 'small' ? '24rem' : '48rem'};
  }
`;

export const typography = (size: string, to?: string) =>
  c('truncate', 'text-text-secondary', { 'hover:text-text-primary': to }, breadcrumb(size));
